module.exports = __webpack_public_path__ + "assets/187866fc1325d9cad1142d9cec9574da.mp3";